function mfgFetch(input, init) {
    const accessToken = window.sessionStorage.getItem('mfg_token');
    init = init || {};
    init.headers = init.headers || {};
    if (accessToken) {
        init.headers.Authorization = `Bearer ${accessToken}`;
    }
    init.headers['Accept'] = 'application/json';
    return window.fetch(input, init)
        .then((resp) => {
            if (resp.status === 401) {
                let url = `https://smartbrush.ddx.dental/mfg/login`;
                if (window.location.href.indexOf("admin") !== -1) {
                    url = `https://smartbrush.ddx.dental/admin/login`;
                }
                window.location = `${url}`;
                return;
            }
            return resp;
        });
}

export default mfgFetch;
